<script setup lang="ts">
import { useCredenzaContext } from './credenzaContext'

const { isMobile } = useCredenzaContext()

const classList = computed(() =>
  twMerge(
    cva('flex flex-col gap-1.5', {
      variants: {
        viewport: {
          mobile: 'px-4 pt-2 pb-4 text-center',
          desktop: 'px-6 pt-6 pb-4',
        },
      },
    })({ viewport: isMobile.value ? 'mobile' : 'desktop' }),
  ),
)
</script>

<template>
  <div :class="classList">
    <slot />
  </div>
</template>
